import { AlertIcon } from './AlertIcon';

/**
 * author: Google
 * id 9FF7DF3F-D575-433B-9C9A-69C58363C186
 * name alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert.svg
 * tags
 * - Alert / Error 
 */
export const ReportProblemIcon = AlertIcon;
export default ReportProblemIcon